module.exports = __webpack_public_path__ + "static/media/I1.159615cc.png";